import axios from 'axios';
import store  from "./store";
import config from './config/env';
import Swal from "sweetalert2";




  

const HTTP = axios.create({
    baseURL: config.BASE_URL,
});

// Add/Update token for each request
HTTP.interceptors.request.use(    
    config => {
        let authUser = localStorage.getItem("token");
        let change_request= localStorage.getItem('change_request');
        if (authUser) {
            config.headers.authorization = "Bearer " + authUser;
            config.headers.Accept = "application/json";
            //config.headers.paths = window.location.href;
            //config.headers.get["Accept"] = "*/*";
            // if (config.method === 'post' || config.method === 'POST') {
            //     // Use method overriding with _method=PUT
            //     // config.data = `_method=PUT&${config.data}`;
            //     if(change_request) {
            //         console.log('change_request123', change_request)
            //        // Use method overriding with _method=PUT
            //         config.data = `_method=PUT&${config.data}`;
            //     }
                
            // }
            //config.headers.get["Content-Type"] = "application/zip; charset=utf-8";
            // config.headers.responseType = 'arraybuffer';
            // config.headers.get["Content-Disposition"] = "attachment";
            // console.log(config.headers);
            // 'Content-Type': 'application/json'
            //config.headers.responseType = 'blob';
            //config.params = {api_token: authUser};      
        }
        
        return config;
    },
    // Do something with request error
    error => {
        Promise.reject(error)}
);

// Add a 401 response interceptor
HTTP.interceptors.response.use(
  (response) => response,
  async (error) => {
    const status = error?.response?.status;
    const message = error?.response?.data?.message || "Something went wrong!";

    switch (status) {
      case 401:
        await store.dispatch("logout");
        await Swal.fire({
          title: "Session Expired",
          text: "Please log in again.",
          type: "warning",
        });
        router.push({ name: "login" });
        break;

      case 403:
        Swal.fire({
          title: "Access Denied",
          text: message,
          type: "warning",
        });
        break;

      case 500:
        Swal.fire({
          title: "Server Error",
          text: message,
          type: "error",
        });
        break;

      default:
        // Optionally handle 400, 404, etc.
        if (status >= 400 && status < 500) {
          Swal.fire({
            title: "Request Failed",
            text: message,
            type: "error",
          });
        }
        break;
    }

    return Promise.reject(error);
  }
);

export default HTTP;